import React, { Component, Suspense } from "react";
import * as ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.css";
import "../css/style.css";
import "../css/purpleresponsive.css";
import Slider from "react-slick";
import { RiArrowRightSLine } from "react-icons/ri";
import { Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Star from "../image/ida/star.png";
//import Header from "../layout/header";
//import Footer from "../layout/footer";
import DoctorList from "./doctor-list-elastic1";
import Search from "../image/ida/search1.png";
import filterimg from "../image/theme/filter.png";
import Pagination from "react-js-pagination";
import { apiCalling, elasticSearchApicall, apiCallingWithoutToken } from "../apiService";
import { elasticLink } from "../config";
import { getSiteData } from "../layout/getSiteDetails";
import $ from "jquery";
import Doctorimg from "../image/ida/doctor.png";
import chat from "../image/theme/chatg.png";
import booking from "../image/theme/inperson.png";
import video from "../image/theme/videog.png";
import call from "../image/theme/phoneg.png";
import Grid from "../image/ida/grid.png";
import List from "../image/ida/list.png";
import Sortby from "../image/ida/sort-by.png"
import Arrowleft from "../image/ida/Arrow_left_light.png"
import { Helmet } from "react-helmet";
import { authHelper, setIsAuthenticated } from "../utilis/authHelper";
import { X } from "react-feather";

let folderName = window.sessionStorage.getItem("homeName");


const AWS = require("aws-sdk");
// const elasticsearch = require("elasticsearch");
AWS.config.region = "us-west-1";

export default class DoctorListMain extends Component {
  searchInputRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      activePage: 1,
      doctorlist: [],
      doctorResult: [],
      hospitalResult: [],
      doctorDataCount: "",
      searchResultCnt: 0,
      searchResult: [],
      specialityResult: [],
      hospitalResult: [],
      doctorResult: [],
      sectionName: "",
      sectionId: "",
      sectionType: "",
      max: 24,
      offset: 0,
      loading: false,
      noData: false,
      s3AccessKey: "",
      s3SecretKey: "",
      doctorServices: [],
      serviceType: this.props?.match?.params?.serviceType,
      randomNum: Math.floor(Math.random() * 10000000),
      locations: [],
      selectedLocation: "",
      filteredLocations: [],
      showCityDropdown: false,
      searchCity: "",
      doctorSearch: "",
      Header: null,
      Footer: null,
    };
    window.sessionStorage.setItem("AppFlag", "NA");
    this.searchClick = this.searchClick.bind(this);
    this.enterSearch = this.enterSearch.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
  }
  getDataFromESSearch(hospitalId, doctorId, specialization, city, state) {
    $(".loadersp").show();
    $("body").css("overflow", "hidden");
    const loginRequest = {
      method: "POST",
      body: JSON.stringify({
        functionName: "doctorList",
        siteId: window.sessionStorage.getItem("siteId"),
        max: this.state.max,
        offset: this.state.offset,
        userId: "",
        state: state,
        city: city,
        doctorId: doctorId,
        hospital: hospitalId,
        specializationId: specialization,
        favouriteDoctorsList: [],
      }),
    };
    $(".loadersp").show();
    apiCalling(loginRequest).then((data) => {
      // console.log("esssssssssssssssssssssss,", data)
      if (data.success === "1") {
        this.hideLoader();
        $("#searchBoxDropdown").hide();
        $(".loadersp").hide();
        $("body").css("overflow", "auto");
        this.setState({
          doctorlist: data.doctorData,
        });
        this.setState({ doctorDataCount: data.doctorDataCount });
        $(".loadersp").hide();
        $("body").css("overflow", "auto");
      }
    });
  }

  hideLoader = () => {
    this.setState({ loading: false });
  };


  handlePageChange(pageNumber) {
    window.scrollTo(0, 0);
    let max = this.state.max;
    let offset = this.state.offset;

    if (pageNumber === "1") {
      offset = "0";
      max = "24";
    } else {
      offset = parseInt(pageNumber - 1) * 24;
      max = "24";
    }

    this.getDoctors(
      offset,
      max,
      this.state.sectionId,
      this.state.sectionType,
      this.state.sectionName
    );
    this.setState({ max: max, offset: offset });
    this.setState({ activePage: pageNumber });
  }

  profileAvailable() {
    $("#drServiceMain1").slideDown(400);
  }
  profileAvailableCancl() {
    $("#drServiceMain1").slideUp(400);
  }
  filtersearch() {
    $("#filter-search-details").slideToggle();
  }

  getDoctorService() {
    const apiJson = {
      method: "POST",
      body: JSON.stringify({
        functionName: "groupService",
        siteId: window.sessionStorage.getItem("siteId"),
      }),
    };
    apiCallingWithoutToken(apiJson).then((data) => {
      var service = [];
      if (data.service) {
        for (let i = 0; i < data.service.length; i++) {
          service.push(data.service[i].serviceId.toString());
        }
      }
      if (data.success === "1") {
        this.setState({
          doctorServices: service,
        });
      }
    })
  }

  // Add city list function
  cityList = async () => {
    const apiJson = {
      method: "POST",
      body: JSON.stringify({
        functionName: "doctorMasterData",
        siteId: window.sessionStorage.getItem("siteId"),
      }),
    };
    apiCallingWithoutToken(apiJson).then((data) => {
      if (data.success === "1") {
        this.setState({
          locations: data.result[0].cityData,
          filteredLocations: data.result[0].cityData
        });
      }
    });
  };

  handleSelectCity = (city) => {
    this.setState({
      selectedLocation: city,
      showCityDropdown: false,
      searchCity: city
    }, () => {
      this.getDoctors(0, 24);
      // // Refresh search with selected city
      // if ($("#doctorSearch").val()) {
      //   this.searchClick();
      // } else {
      //   this.getDoctors(0, 24);
      // }
    });
  };
  // getLoadHomePage() {
  //   if (!this.state.siteId) {
  //     const jsonReq = {
  //       method: "POST",
  //       body: JSON.stringify({
  //         functionName: "getSiteDetails",
  //         siteId: "",
  //         siteUrl: window.location.host,
  //       }),
  //     };
  //     apiCallingWithoutToken(jsonReq).then((data) => {
  //       if (data.success === "1") {
  //         // alert('ok')
  //         //  data.siteDetailsData[0].siteData[0].themeName
  //       }
  //     });
  //   }
  // }
  componentDidMount() {
    // debugger
    this.loadLayoutComponents();
    $(document).mouseup((e) => {
      const cityInput = $("#citySearchInput"); // We'll add an id to the input
      const cityDropdown = $(".city-dropdown"); // We'll add a class to the ul

      if (!cityInput.is(e.target) && !cityDropdown.is(e.target) && cityDropdown.has(e.target).length === 0) {
        this.setState({ showCityDropdown: false });
      }
    });
    if (this.searchInputRef.current) {
      this.searchInputRef.current.setAttribute('autocomplete', 'off');
      this.searchInputRef.current.setAttribute('autocorrect', 'off');
      this.searchInputRef.current.setAttribute('autocapitalize', 'off');
      this.searchInputRef.current.setAttribute('spellcheck', 'false');
    }
    $(".loadersp").show();
    if (folderName === null) {
      window.sessionStorage.setItem("pathname", window.location.pathname);
      // window.location.href = "/";
    }
    if (window.sessionStorage.getItem("isLogin") == true) this.getFavourites();
    this.getDoctorService();
    this.cityList(); // Load city list

    // Enhanced URL parameter handling
    const urlParams = new URLSearchParams(window.location.search);
    const searchType = urlParams.get('type');
    const searchId = urlParams.get('id');
    // const searchName = urlParams.get('name');
    const searchNameEncoded = urlParams.get('name');
    const searchCity = urlParams.get('city');
    // Check if we have URL parameters (highest priority)
    const searchName = searchNameEncoded ? decodeURIComponent(searchNameEncoded) : null;
    if (searchType === "SEARCH") {
      $("#doctorSearch").val(searchName || "");
      this.setState({
        doctorSearch: $("#doctorSearch").val(),
        sectionName: decodeURIComponent(searchName) || "",
        sectionId: "",
        sectionType: "SEARCH",
      }, () => {
        // Trigger search with the query
        this.searchClick();
      });
    }
    if (searchType === "DOCTORS" || searchType === "HOSPITAL") {
      $("#doctorSearch").val(searchName || "");
      this.setState({
        doctorSearch: $("#doctorSearch").val()
      });
      const storedCity = window.sessionStorage.getItem("selectedCity");
      if (storedCity) {
        this.setState({
          selectedLocation: storedCity,
          searchCity: searchCity || storedCity,
        });
      }
    }
    if (searchType === "SPECIALITIES") {
      this.setState({
        doctorSearch: $("#doctorSearch").val()
      });
      const storedCity = window.sessionStorage.getItem("selectedCity");
      if (storedCity) {
        this.setState({
          selectedLocation: storedCity,
          searchCity: storedCity
        });
      }
    }
    if (searchType && searchId && searchName) {
      // Set the search input value
      $("#doctorSearch").val(searchName);
      this.setState({
        doctorSearch: $("#doctorSearch").val()
      });
      // Set city if provided
      if (searchCity) {
        this.setState({
          selectedLocation: decodeURIComponent(searchCity),
          searchCity: searchCity
        });
      }

      this.setState({
        sectionName: decodeURIComponent(searchName),
        sectionId: searchId,
        sectionType: searchType.toUpperCase(),
      }, () => {
        // this.getDataFromESSearch(searchId, "", "", searchCity, "")
        this.searchClick(0, 24, searchId, searchType.toUpperCase(), decodeURIComponent(searchName));
      });
    }
    // Check for session storage data (fallback)
    // else if (window.sessionStorage.getItem("sectionName") &&
    //   window.sessionStorage.getItem("sectionName") !== "") {
    //   this.loadData(
    //     window.sessionStorage.getItem("sectionId"),
    //     window.sessionStorage.getItem("sectionType"),
    //     window.sessionStorage.getItem("sectionName")
    //   );

    //   // Also set city from session storage if available
    //   const storedCity = window.sessionStorage.getItem("selectedCity");
    //   if (storedCity) {
    //     this.setState({ selectedLocation: storedCity });
    //   }
    // }
    // Default case - load all doctors
    else {
      this.setState({
        selectedLocation: decodeURIComponent(searchCity),
        searchCity: searchCity
      }, () => {
        this.getDoctors(0, 24);
        // this.searchClick(0,24);
      });

    }

    $(document).mouseup(function (e) {
      var container = $(".searchBoxDropdown");
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.hide();
      }
    });
  }
  loadLayoutComponents = async () => {
    try {
      // Wait for sessionStorage to be populated
      let folderName = await this.getFolderName();

      const HeaderModule = await import(`../${folderName}/header`);
      const FooterModule = await import(`../${folderName}/footer`);

      this.setState({
        Header: HeaderModule.default,
        Footer: FooterModule.default,
        loading: false
      });
    } catch (error) {
      console.error("Failed to load layout components:", error);
      // Fallback to default layout
      this.loadFallbackLayout();
    }
  }
  getFolderName = () => {
    return new Promise((resolve) => {
      let attempts = 0;
      const maxAttempts = 50; // 5 seconds total

      const checkFolderName = () => {
        const folderName = window.sessionStorage.getItem("homeName");

        if (folderName && folderName !== "null") {
          resolve(folderName);
        } else if (attempts < maxAttempts) {
          attempts++;
          setTimeout(checkFolderName, 100); // Check every 100ms
        } else {
          resolve("layout"); // Default fallback
        }
      };

      checkFolderName();
    });
  }
  loadFallbackLayout = async () => {
    try {
      const HeaderModule = await import("../layout/header");
      const FooterModule = await import("../layout/footer");

      this.setState({
        Header: HeaderModule.default,
        Footer: FooterModule.default,
        loading: false
      });
    } catch (fallbackError) {
      console.error("Fallback layout also failed:", fallbackError);
      this.setState({ loading: false });
    }
  }
  getFavourites() {
    const apiJson = {
      method: "POST",
      body: JSON.stringify({
        functionName: "myFavourites",
        userId: authHelper.getUserId(),
      }),
    };
    apiCalling(apiJson).then((data) => {
      // Favourites logic here
    });
  }

  loadData(sectionId, sectionType, sectionName) {
    $("#doctorSearch").val(sectionName);
    this.enterSearch();
    window.scrollTo(0, 0);

    this.setState({
      sectionName: sectionName,
      sectionId: sectionId,
      sectionType: sectionType.toUpperCase(),
    });
    this.getDoctors(0, 24);
  }

  async getDoctors(offset, max, sectionId, sectionType, sectionName) {
    // debugger
    $(".searchBoxDropdown").hide();
    var hospitalId = "",
      stateId = "",
      cityName = this.state.searchCity || "",
      doctorIds = "",
      SpecialitiesOrMedicinBranch = "",
      spetialityId = "",
      inperson = this.state.serviceType === "1" ? "1" : "*",
      chat = this.state.serviceType === "2" ? "1" : "*",
      video = this.state.serviceType === "3" ? "1" : "*",
      audio = this.state.serviceType === "4" ? "1" : "*";

    if (sectionType === "HOSPITAL") {
      hospitalId = sectionId;
    } else if (sectionType === "STATE") {
      stateId = sectionId;
    } else if (sectionType === "CITY") {
      cityName = sectionName;
    } else if (sectionType === "SYMPTOM") {
      doctorIds = sectionId;
    } else if (sectionType === "COMMON NAME") {
      SpecialitiesOrMedicinBranch = sectionId;
    } else if (sectionType === "SPECIALITY") {
      spetialityId = sectionId;
    }

    var siteId = window.sessionStorage.getItem("siteId");
    var isExcludeFromPH = siteId == "" ? "0" : "1";
    var fields = [];
    var paramsVal = [];

    if (siteId == "") {
      fields = [
        "site_id", "section_type.keyword", "hospital_id.keyword", "stateid.keyword",
        "section_id.keyword", "specialization_id.keyword",
        "specialization_id.keyword", "is_call_enabled", "is_chat_enabled",
        "is_video_enabled", "ishosonline", "is_exclude_from_ph"
      ];
      paramsVal = [
        siteId, window.sessionStorage.getItem("siteId") ? "DOCTORBYHOSPITAL" : "DOCTORBYHOSPITAL",
        hospitalId, stateId, doctorIds, SpecialitiesOrMedicinBranch,
        spetialityId, audio, chat, video, inperson, isExcludeFromPH
      ];
    } else {
      fields = [
        "site_id", "section_type.keyword", "hospital_id.keyword", "stateid.keyword",
        "section_id.keyword", "specialization_id.keyword",
        "specialization_id.keyword", "is_call_enabled", "is_chat_enabled",
        "is_video_enabled", "ishosonline"
      ];
      paramsVal = [
        siteId, window.sessionStorage.getItem("siteId") ? "DOCTORBYHOSPITAL" : "DOCTORBYHOSPITAL",
        hospitalId, stateId, doctorIds, SpecialitiesOrMedicinBranch,
        spetialityId, audio, chat, video, inperson
      ];
    }

    var filters = [];
    for (var k = 0; k < fields.length; k++) {
      if (paramsVal[k] !== null && paramsVal[k] !== "" && paramsVal[k] !== "*") {
        var termq = { term: {} };
        termq.term[fields[k]] = paramsVal[k];
        filters.push(termq);
      }
    }

    // ✅ FIX: Add city filter with bool/should structure
    // if (cityName) {
    //   const cityFilter = {
    //     bool: {
    //       should: [
    //         { term: { "city": cityName.toLowerCase() } },
    //         { term: { "city.keyword": cityName } }
    //       ]
    //     }
    //   };
    //   filters.push(cityFilter);
    // }

    if ($("#doctorSearch").val() !== "") {
      const apiJson = {
        "index": elasticLink(),
        "offset": offset,
        "max": max,
        "searchBody": {
          query: {
            bool: {
              must: {
                multi_match: {
                  query: $("#doctorSearch").val(),
                  type: "phrase_prefix",
                  fields: ["search_field"],
                },
              },
              filter: {
                bool: {
                  must: filters, // This now includes the proper city filter
                },
              },
            },
          },
          sort: {
            _script: {
              script: "(doc['_id'].value + " + this.state.randomNum + ").hashCode()",
              type: "number",
              order: "asc",
            },
          },
        },
      }
      const response = await elasticSearchApicall(apiJson);
      this.setState({
        doctorlist: response?.result?.hits?.hits,
        doctorDataCount: response?.result?.hits?.total.value,
      });
    } else {
      const apiJson = {
        "index": elasticLink(),
        "offset": offset,
        "max": max,
        "searchBody": {
          query: {
            bool: {
              filter: {
                bool: {
                  must: filters, // This now includes the proper city filter
                },
              },
            },
          },
          sort: {
            _script: {
              script: "(doc['_id'].value + " + this.state.randomNum + ").hashCode()",
              type: "number",
              order: "asc",
            },
          },
        },
      }
      const response = await elasticSearchApicall(apiJson);
      // console.log("responseeeeeeeeeeeeeeeeee", response)
      this.setState({
        doctorlist: response?.result?.hits.hits,
        doctorDataCount: response.result.hits.total.value,
      });
    }
    setTimeout(() => {
      $(".loadersp").hide()
    }, 500);
  }

  loadInitData() {
    $(".loadersp").show();
    $("body").css("overflow", "hidden");
    const jsonObj = {
      method: "POST",
      body: JSON.stringify({
        functionName: "doctorList",
        siteId: window.sessionStorage.getItem("siteId"),
        max: this.state.max,
        offset: this.state.offset,
      }),
    };

    apiCalling(jsonObj).then((data) => {
      // console.log("initdaaaaaaaaaaaaaa", data)
      if (data.success === "1") {
        this.setState({
          doctorlist: data.doctorData,
        });
        this.setState({ doctorDataCount: data.doctorDataCount });
        $(".loadersp").hide();
        $("body").css("overflow", "auto");
      }
    });
  }

  clearSearch() {
    // 1. Clear the search input field
    $("#doctorSearch").val("");

    // 2. Clear all relevant state variables
    this.setState({
      sectionName: "",
      sectionId: "",
      sectionType: "",
      doctorSearch: "",
      max: 24,
      offset: 0,
      activePage: 1,
      searchCity: "",
      selectedLocation: "", // Clear city filter
    }, () => {
      // 3. (Callback) Update the URL to remove search parameters
      // const newUrl = window.location.pathname;
      // window.history.pushState({}, '', newUrl);

      // 4. (Callback) Refetch the doctor list with the cleared state (page 1, all doctors/default city)
      // The arguments are optional since getDoctors now uses the state by default.
      this.getDoctors(0, 24);
    });
  }

  enterSearch() {
    if ($("#doctorSearch").val() !== "" && $("#doctorSearch").val().length >= 1 && this.state.noData === true) {
      $(".searchBoxDropdown").hide();
      // this.setState({
      //   sectionName: $("#doctorSearch").val(),
      //   sectionId: "",
      //   sectionType: "",
      // });
      this.getDoctors(0, 24);
    } else {
      $("#doctorSearch").focus();
    }
  }

  // Enhanced redirect function to handle all search types

  // Enhanced redirect function to handle all search types with complete state preservation
  redirectingLinkSearch = (sectionName, sectionType, sectionId, hospitalData = null) => {
    // If hospital data is provided, extract city from location
    let targetCity = this.state.selectedLocation;
    if (hospitalData && hospitalData.subSectionName) {
      const extractedCity = hospitalData.subSectionName.split(',')[0]?.trim();
      if (extractedCity) {
        targetCity = extractedCity;
        this.setState({ selectedLocation: extractedCity });
      }
    }

    // Store all search data in session storage
    window.sessionStorage.setItem("searchTerm", sectionName || "");
    window.sessionStorage.setItem("selectedCity", targetCity || "");
    window.sessionStorage.setItem("sectionName", sectionName || "");
    window.sessionStorage.setItem("sectionType", sectionType || "");
    window.sessionStorage.setItem("sectionId", sectionId || "");

    // Set the search input value
    $("#doctorSearch").val(sectionName);

    this.setState({
      sectionName: sectionName,
      sectionId: sectionId,
      sectionType: sectionType.toUpperCase(),
    });

    // Update URL with all parameters including city
    const urlParams = new URLSearchParams();
    urlParams.set('type', sectionType);
    urlParams.set('id', sectionId);
    urlParams.set('name', encodeURIComponent(sectionName));
    if (targetCity) {
      urlParams.set('city', encodeURIComponent(targetCity));
    }

    const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
    window.history.pushState({}, '', newUrl);

    // Pass all filters to getDoctors
    this.getDoctors(0, 24, sectionId, sectionType.toUpperCase(), sectionName);
  };
  // _handleKeyDown = (e) => {

  //   if (e.key === "Enter") {
  //     if ($("#doctorSearch").val() !== "" && $("#doctorSearch").val().length >= 1 && this.state.noData === true) {
  //       $(".searchBoxDropdown").hide();

  //       this.getDoctors(0, 24);
  //     } else {
  //       $("#doctorSearch").focus();
  //     }
  //   }
  // };
  searchClick = async (flag = false) => {
    if (flag === true) {
      $(".loadersp").show();
    }
    this.setState({
      sectionName: $("#doctorSearch").val(),
      sectionId: "",
      sectionType: "",
      doctorSearch: $("#doctorSearch").val()
    });
    let query = $("#doctorSearch").val();
    // if (!query || query.trim().length < 1) {
    //   $(".searchBoxDropdown").hide();
    //   // setNoData(true);
    //   return;
    // }
    if (!query && !this.state.searchCity) {
      this.clearSearch()
      return
    }
    else if (!query) {
      this.getDoctors(0, 24)
      return
    }
    const siteId = window.sessionStorage.getItem("siteId");
    const filters = [{ term: { site_id: siteId } },
    { term: { 'section_type.keyword': "DOCTORBYHOSPITAL" } }
    ];

    // ✅ City filter added here
    // if (this.state.selectedLocation != "null" && this.state.selectedLocation !== "") {
    //   filters.push({
    //     bool: {
    //       should: [

    //         { term: { "city": this.state.selectedLocation.toLowerCase() } },
    //         { term: { "city.keyword": this.state.selectedLocation } }, // fallback
    //       ],
    //     },
    //   });
    // }
    // if (this.state.sectionName) {
    //   filters.push({
    //     bool: {
    //       should: [

    //         { term: { "sectionName": this.state.sectionName.toLowerCase() } },
    //         { term: { "sectionName.keyword": this.state.sectionName } }, // fallback
    //       ],
    //     },
    //   });
    // }
    //     const body = {
    //   "index": "ph-prod-search",
    //   "offset": 0,
    //   "max": 24,
    //   "searchBody": {
    //     "query": {
    //       "bool": {
    //         "must": [
    //           {
    //             "multi_match": {
    //               "query": query,
    //               "type": "best_fields",
    //               "fields": [
    //                 "section_name^5",
    //                 "hospitalname^4",
    //                 "search_field^3",
    //                 "city^3",
    //                 "state^2",
    //                 "speciality^3",
    //                 "sub_section_name^3",
    //                 "professionalstatement^2"
    //               ],
    //               "fuzziness": "AUTO",
    //               "prefix_length": 1,
    //               "operator": "and"
    //             }
    //           },
    //           {
    //             "multi_match": {
    //               "query": query,
    //               "type": "cross_fields",
    //               "fields": [
    //                 "section_name^5",
    //                 "hospitalname^4",
    //                 "city^3",
    //                 "state^2",
    //                 "speciality^3",
    //                 "search_field^3"
    //               ],
    //               "minimum_should_match": "70%"
    //             }
    //           }
    //         ],
    //         "should": [
    //           {
    //             "multi_match": {
    //               "query": query,
    //               "type": "phrase_prefix",
    //               "fields": [
    //                 "section_name^5",
    //                 "hospitalname^4",
    //                 "search_field^3",
    //                 "city^2",
    //                 "state^2",
    //                 "speciality^3"
    //               ]
    //             }
    //           },
    //           {
    //             "wildcard": {
    //               "section_name.keyword": {
    //                 "value": "*bob*",
    //                 "boost": 3
    //               }
    //             }
    //           },
    //           {
    //             "wildcard": {
    //               "hospitalname.keyword": {
    //                 "value": "*bob*",
    //                 "boost": 2
    //               }
    //             }
    //           }
    //         ],
    //         "filter": {
    //           "bool": {
    //             "must": [
    //               { "term": { "site_id": "1" } },
    //               { "term": { "section_type.keyword": "DOCTORBYHOSPITAL" } }
    //             ]
    //           }
    //         }
    //       }
    //     },
    //     "sort": [
    //       { "_score": { "order": "desc" } },
    //       {
    //         "_script": {
    //           "script": "(doc['_id'].value + 6549421).hashCode()",
    //           "type": "number",
    //           "order": "asc"
    //         }
    //       }
    //     ]
    //   }
    // }


    //     const body = {
    //       index: elasticLink(),
    //       offset: 0,
    //       max: 24,
    //       searchBody: {
    //         query: {
    //           bool: {
    //             must: {
    //               multi_match: {
    //                 query,
    //                 type: "best_fields",
    //                 fields: ["search_field"],
    //                 fuzziness: "AUTO",
    //               },

    //             },
    //             filter: {
    //               bool: { must: filters },
    //             },
    //           },
    //         },
    //         sort: [
    //   {
    //     _script: {
    //       type: "number",
    //       order: "desc",
    //       script: {
    //         source: `
    //           def exact = 0;
    //           if (doc['search_field.keyword'].size() > 0 && 
    //               doc['search_field.keyword'].value.equalsIgnoreCase(params.query)) {
    //             exact = 100;
    //           }
    //           return _score + exact;
    //         `,
    //         params: { query },
    //       },
    //     },
    //   },
    //   {
    //     _script: {
    //       script: "(doc['_id'].value + " + this.state.randomNum + ").hashCode()",
    //       type: "number",
    //       order: "asc",
    //     },
    //   },
    // ],

    //       },
    //     };
    // const body ={
    //     "query": {
    //         "bool": {
    //             "should": [
    //                 {
    //                     "multi_match": {
    //                         "query": query,
    //                         "type": "phrase_prefix",
    //                         "fields": [
    //                             "search_field^20"
    //                         ]
    //                     }
    //                 },
    //                 {
    //                     "query_string": {
    //                         "query": query, 
    //                         "fields": [
    //                             "section_name^5",
    //                             "hospitalname^4",
    //                             "city^3",
    //                             "state^2",
    //                             "speciality^3"
    //                         ],
    //                         "default_operator": "AND"
    //                     }
    //                 },
    //                 {
    //                     "wildcard": {
    //                         "section_name.keyword": {
    //                             "value": query,
    //                             "boost": 3
    //                         }
    //                     }
    //                 },
    //                 {
    //                     "wildcard": {
    //                         "hospitalname.keyword": {
    //                             "value": query,
    //                             "boost": 2
    //                         }
    //                     }
    //                 }
    //             ],
    //             "minimum_should_match": 1,
    //             "filter": {
    //                 "bool": {
    //                     "must": [
    //                         {
    //                             "term": {
    //                                 "site_id": "1"
    //                             }
    //                         },
    //                         {
    //                             "term": {
    //                                 "section_type.keyword": "DOCTORBYHOSPITAL"
    //                             }
    //                         }
    //                     ]
    //                 }
    //             }
    //         }
    //     },
    //     "sort": [
    //         {
    //             "_score": {
    //                 "order": "desc"
    //             }
    //         },
    //         {
    //             "_script": {
    //                 "script": "(doc['_id'].value + 6549421).hashCode()",
    //                 "type": "number",
    //                 "order": "asc"
    //             }
    //         }
    //     ]
    // }
    const body = {
      index: elasticLink(),
      offset: 0,
      max: 24,
      searchBody: {
        query: {
          function_score: {
            query: {
              bool: {
                must: [
                  {
                    multi_match: {
                      query,
                      type: "best_fields",
                      fields: ["search_field"],
                      fuzziness: "AUTO",

                    },
                  },
                ],
                filter: {
                  bool: { must: filters },
                },
              },
            },
            functions: [
              {
                filter: {
                  term: { "search_field.keyword": query.toLowerCase() },
                },
                weight: 10, // Boost exact matches 5x
              },
            ],
            boost_mode: "sum",
            score_mode: "max",
          },
        },
        sort: [
          {
            _script: {
              type: "number",
              order: "desc",
              script: {
                source: `
          def exact = 0;
          if (doc['search_field.keyword'].size() > 0 && 
              doc['search_field.keyword'].value.equalsIgnoreCase(params.query)) {
            exact = 100;
          }
          return _score + exact;
        `,
                params: { query },
              },
            },
          },
          {
            _script: {
              script: "(doc['_id'].value + " + this.state.randomNum + ").hashCode()",
              type: "number",
              order: "asc",
            },
          },
        ],

      },
    };

    const response = await elasticSearchApicall(body);
    const result = response?.result?.hits?.hits || [];
    const doctors = [];
    const hospitals = [];
    const specialities = [];
    result?.forEach((r) => {
      const s = r._source;
      const obj = {
        sectionName: s.section_name,
        sectionId: s.section_id,
        sectionType: s.section_type,
        sectionImage: s.section_image_with_path,
        isOnline: s.doctor_online,
        subSectionName: s.sub_section_name,
        slug: s?.slug,
        hasInperson: s.ishosonline && this.state.doctorServices.toString().includes("4") ? "1" : "0",
        hasVideo: s.is_video_enabled === "1" && this.state.doctorServices.toString().includes("1") ? "1" : "0",
        hasCall: s.is_call_enabled && this.state.doctorServices.toString().includes("5") ? "1" : "0",
        hasChat: s.is_chat_enabled && this.state.doctorServices.toString().includes("2") ? "1" : "0",
        // hasInperson:
        //   s?.ishosonline && doctorServices.includes("4") ? "1" : "0",
        // hasVideo:
        //   s?.is_video_enabled === "1" && doctorServices.includes("1") ? "1" : "0",
        // hasCall:
        //   s?.is_call_enabled && doctorServices.includes("5") ? "1" : "0",
        // hasChat:
        //   s?.is_chat_enabled && doctorServices.includes("2") ? "1" : "0",
      };

      if (s.section_type === "DOCTORBYHOSPITAL") doctors.push(obj);
      // else if (s.section_type === "HOSPITAL") hospitals.push(obj);
      // else specialities.push(obj);
    });
    if (result.length > 0) {
      let filteredDoctorData = response.result.hits.hits?.filter((obj) => (obj._source.section_type === "DOCTORBYHOSPITAL"))
      this.setState({
        doctorlist: filteredDoctorData,
        doctorDataCount: response.result.hits.total.value,
      });
      this.setState({ searchResult: [], noData: true });
      $(".searchBoxDropdown").show();
    } else {
      this.setState({ searchResult: [], noData: false });
      this.setState({
        doctorlist: response.result.hits.hits,
        doctorDataCount: response.result.hits.total.value,
      });
    }
    $(".loadersp").hide();
  };


  uniqueNames = (arr) => {
    const uniqueNameSet = new Set();
    return arr.filter((obj) => {
      if (!uniqueNameSet.has(obj.sectionName)) {
        uniqueNameSet.add(obj.sectionName);
        return true;
      }
      return false;
    });
  };

  isLoginValidate(doctorId, hospitalId, flagOption, bySlot, slug) {
    window.sessionStorage.setItem("IDASlug", slug);
    if (window.sessionStorage.getItem("isLogin") == "true") {
      window.sessionStorage.setItem("loginValidate", "");
      window.sessionStorage.setItem("appDocId", doctorId);
      window.sessionStorage.setItem("appHosId", hospitalId);
      window.sessionStorage.setItem("flagOption", flagOption);
      window.sessionStorage.setItem("bySlot", bySlot);
      if (slug) {
        window.location.href = "/Doctor-" + slug;
      }
    } else {
      window.sessionStorage.setItem("loginValidate", "book");
      window.sessionStorage.setItem("appDocId", doctorId);
      window.sessionStorage.setItem("appHosId", hospitalId);
      window.sessionStorage.setItem("flagOption", flagOption);
      window.sessionStorage.setItem("bySlot", bySlot);
      $("#ForgotPasswordWrap").hide();
      $("#SignupWrap").hide();
      $("#signInWrapDiv").show();
    }
  }

  srcDrImage(drImg) {
    const doctorAvatar = drImg?.split("/").pop();
    return (
      <img
        src={(doctorAvatar == "avatarGirlDefault.png" || doctorAvatar == "avatarBoyDefault.png") ?
          Doctorimg : drImg
        }
        alt=""
        width={105}
      ></img>
    )
  }

  goBackButton = () => {
    window.history.back();
  }
  // Update city input focus handler
  handleCityInputFocus = () => {
    this.setState({
      showCityDropdown: true,
      filteredLocations: this.state.locations // Reset to show all cities when focusing
    });
  }

  // Update city search handler
  handleCitySearch = (e) => {
    let text = e.target.value;

    this.setState({
      searchCity: text,
      showCityDropdown: true // Keep dropdown open when searching
    });

    if (!$("#doctorSearch").val() && !text) {
      this.clearSearch()
      return
    }
    const filtered = this.state.locations.filter((loc) =>
      loc.cityName.toLowerCase().includes(text.toLowerCase())
    );
    this.setState({ filteredLocations: filtered });

    clearTimeout(this.citySearchTimer);
    this.citySearchTimer = setTimeout(() => {
      // Check if typed city matches any known location
      const matchedCity = this.state.locations.find(
        (loc) => loc.cityName.toLowerCase() === text.toLowerCase()
      );

      if (matchedCity) {
        this.setState(
          {
            selectedLocation: matchedCity.cityName,
            showCityDropdown: false,
          },
          () => {
            // Automatically fetch doctors
            if ($("#doctorSearch").val()) {
              this.searchClick();
            } else {
              this.getDoctors(0, 24);
            }
          }
        );
      }
    }, 700); // 700ms debounce
  }

  // Update city selection handler
  handleSelectCity = (city, e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    this.setState({
      selectedLocation: city,
      searchCity: city, // Set the input text to the selected city
      showCityDropdown: false
    }, () => {
      // Refresh search with selected city
      if ($("#doctorSearch").val()) {
        this.searchClick();
      } else {
        this.getDoctors(0, 24);
      }
    });
  }

  render() {
    const { Header, Footer } = this.state;

    return (
      <div className="purpleWrap">
        <Suspense fallback={<div></div>}>
          <section>
            {Header && <Header currentPage="true" />}
          </section>
        </Suspense>
        <Helmet>
          <title>
            {"Doctor's | " + window.sessionStorage.getItem("siteName")}
          </title>
          <meta
            name="description"
            content={"Doctor's | " + window.sessionStorage.getItem("siteName")}
          />
        </Helmet>
        <div class="loadersp"></div>
        <div className="container-fluid drListMain px-0">
          <div className="telehealthfeaturehead text-md-left">
            <div className="breadcrumb-main mb-1">
              <ul className="bread-crumb-ul">
                <li className="breadcrumb-light">
                  <Link to={"/"} >Home</Link>
                </li>
                <li>
                  <RiArrowRightSLine />
                </li>
                <li>Doctors</li>
              </ul>
            </div>
            <span>
              <img src={Arrowleft} alt="arrowleft" className="img-fluid mr-2 cursor-pointer" onClick={() => this.goBackButton()} />
            </span>
            Doctors ({this.state.doctorDataCount})
          </div>

          {/* {this.state.doctorDataCount === 0 ? (
            <div className="no_doctors">No Doctors Available</div>
          ) : (
            ""
          )} */}
          <div className="container drListMain">
            <div className="doctorDetailMain my-4">
              <div className="filter-search-wrapper mb-2">
                {/* Enhanced Search with City Filter */}
                <div className="drSearch w-100 d-md-flex" style={{ alignItems: "center" }}>
                  {/* City Filter Dropdown */}
                  {/* City Filter Dropdown */}
                  {/* <div style={{ position: "relative" }}>
                    <input
                      type="text"
                      autoComplete="off"
                      value={this.state.searchCity}
                      onChange={this.handleCitySearch}
                      onFocus={this.handleCityInputFocus}
                      className="form-control citysearch"
                      id="citySearchInput" // Add this ID
                      placeholder="Select city"
                      style={{ minWidth: "160px" }}
                    />
                    {this.state.showCityDropdown && this.state.filteredLocations.length > 0 && (
                      <ul className="search-ul" style={{
                        position: "absolute",
                        top: "100%",
                        left: "0",
                        right: "0",
                        background: "#fff",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        maxHeight: "200px",
                        overflowY: "auto",
                        zIndex: 1000,
                        marginTop: "2px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        padding: "0",
                        listStyle: "none"
                      }}>
                        {this.state.filteredLocations.map((loc) => (
                          <li
                            onMouseDown={(e) => this.handleSelectCity(loc.cityName, e)}
                            onClick={(e) => this.handleSelectCity(loc.cityName, e)}
                            className="search-nav"
                            key={loc.cityId || loc.cityName}
                            style={{
                              padding: "8px 12px",
                              cursor: "pointer",
                              borderBottom: "1px solid #f0f0f0",
                              backgroundColor: this.state.selectedLocation === loc.cityName ? "#eef" : "transparent"
                            }}
                          >
                            {loc.cityName}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div> */}

                  {/* Search Input */}
                  <div style={{ position: "relative", flexGrow: 1 }}>
                    {/* <img src={Search}
                      alt="Search"
                      width="16"
                      height={16}
                      // onClick={() => this.enterSearch()}
                      style={{
                        cursor: "pointer",
                        position: "absolute",
                        left: "10px",
                        top: "10px",
                        zIndex: 1
                      }}
                    /> */}
                    <div className="d-flex align-items-center form-control-div">
                      <div className="w-100 position-relative">
                        <input
                          // onKeyDown={this._handleKeyDown}
                          autoComplete="off"
                          type="text"
                          className="form-control"
                          ref={this.searchInputRef}
                          id="doctorSearch"
                          placeholder="Search doctors, hospitals, specialities"
                          onChange={() => this.searchClick()}
                          style={{ paddingLeft: "15px" }}
                        ></input>
                        <button type="button" className="search-btn-doc"
                          style={{ flex: 'none' }}
                          onClick={() => this.searchClick(true)}
                        >Search</button>
                      </div>
                      {/* {this.state.doctorSearch != "" && (
                        <a onClick={() => this.clearSearch()} className="ml-2 clear-search"
                          style={{ flex: 'none', lineheight: "15px" }}>
                          Clear Search
                        </a>)} */}
                      {this.state.sectionName != "" ? (
                        <div className="drClearSearch">
                          <div className="drClearSearchSub">
                            Search result for "{this.state.sectionName}"
                            <span title="Clear Search" onClick={() => this.clearSearch()}>X</span>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>

                    {/* Enhanced Search Dropdown */}
                    {/* <div className="searchBoxDropdown mt-2" id="searchBoxDropdown" style={{ width: "100%" }}> */}
                    {this.state.doctorlist < 1 ? (
                      <></>
                    ) : (
                      <div className="searchBoxFound">
                        {/* Doctors Section */}
                        {this.state.doctorResult.length > 0 && (
                          <>
                            <div className="searchBoxCount">
                              <span>DOCTORS</span>
                            </div>
                            <div className="searchBoxList">
                              {this.state.doctorResult.slice(0, 5).map((data, index) => {
                                let slug = data.slug + " ";
                                slug = slug.toString();
                                slug = slug.split("|").join("-");
                                slug = slug.split(" ").join("-");
                                slug = slug.split(".-").join(".");
                                slug = slug.split("--").join("-");
                                slug = slug.slice(0, -1) + "";

                                return slug ? (
                                  <div className="searchBoxItem" key={data.sectionId || index}>
                                    <div className="searchDocImg">
                                      <Link to={`/Doctor-${slug}`}>
                                        {this.srcDrImage(data.sectionImage)}
                                      </Link>
                                    </div>
                                    <div className="searchDocDeatils">
                                      <Link to={`/Doctor-${slug}`}>
                                        <div className="searchDocName">{data.sectionName}</div>
                                        <div className="searchDocDesignation">
                                          {data.subSectionName}, {data.hospitalname}
                                        </div>
                                      </Link>
                                      <div className="searchDocService">
                                        {data.hasInperson === "1" && <img src={booking} alt="inperson" />}
                                        {data.hasVideo === "1" && <img src={video} alt="video" />}
                                        {data.hasCall === "1" && <img src={call} alt="call" />}
                                        {data.hasChat === "1" && <img src={chat} alt="chat" />}
                                      </div>
                                    </div>
                                  </div>
                                ) : null;
                              })}
                            </div>
                          </>
                        )}

                        {/* Specialities Section */}
                        {/* Specialities Section */}
                        {this.state.specialityResult.length > 0 && (
                          <>
                            <div className="searchBoxCount">
                              <span>SPECIALITIES</span>
                            </div>
                            <div className="searchBoxList">
                              {this.state.specialityResult.map((data, index) => {
                                return (
                                  <div className="searchBoxItem" key={data.sectionId || index}>
                                    <div className="searchDocDeatils searchSplDeatils">
                                      <div
                                        className="cursor-pointer"
                                        onClick={() => this.redirectingLinkSearch(data.sectionName, "SPECIALITY", data.sectionId)}
                                      >
                                        <div className="searchDocName">{data.sectionName}</div>
                                        {data.subSectionName && (
                                          <div className="searchDocDesignation">{data.subSectionName}</div>
                                        )}
                                        {/* Show selected city if any */}
                                        {this.state.selectedLocation && (
                                          <div className="searchDocCity" style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}>
                                            📍 {this.state.selectedLocation}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </>
                        )}

                        {this.state.hospitalResult.length > 0 && (
                          <>
                            <div className="searchBoxCount">
                              <span>HOSPITALS</span>
                            </div>
                            <div className="searchBoxList">
                              {this.state.hospitalResult.map((data, index) => {
                                return (
                                  <div className="searchBoxItem" key={data.sectionId || index}>
                                    <div className="searchDocImg">
                                      <div
                                        className="cursor-pointer"
                                        onClick={() => this.redirectingLinkSearch(data.sectionName, "HOSPITAL", data.sectionId, data)}
                                      >
                                        <img src={data.sectionImage} alt="" width={105} />
                                      </div>
                                    </div>
                                    <div className="searchDocDeatils">
                                      <div
                                        className="cursor-pointer"
                                        onClick={() => this.redirectingLinkSearch(data.sectionName, "HOSPITAL", data.sectionId, data)}
                                      >
                                        <div className="searchDocName">{data.sectionName}</div>
                                        <div className="searchDocDesignation">{data.subSectionName}</div>
                                        {/* Show city and allow clicking to select it */}
                                        {data.subSectionName && (
                                          <div
                                            className="searchDocCity"
                                            style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              const city = data.subSectionName.split(',')[0]?.trim();
                                              if (city) {
                                                this.handleSelectCity(city);
                                                // After selecting city, refresh the search
                                                setTimeout(() => {
                                                  this.redirectingLinkSearch(data.sectionName, "HOSPITAL", data.sectionId, data);
                                                }, 100);
                                              }
                                            }}
                                          >
                                            📍 {data.subSectionName.split(',')[0]?.trim() || 'Multiple locations'}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </>
                        )}
                      </div>
                    )}
                    {/* </div> */}
                  </div>

                </div>
              </div>
              {!this.state.doctorlist.length ?
                <div className="noDoctorList nodata-found">No results found</div> : ""}
              {/* Doctor List */}
              {this.state.doctorlist.map((obj, index) => {
                let slug = obj._source.slug + " ";
                slug = slug.toString();
                slug = slug.split("|").join("-");
                slug = slug.split(" ").join("-");
                slug = slug.split(".-").join(".");
                slug = slug.split("--").join("-");
                slug = slug.slice(0, -1) + "";

                // if (slug) {
                return (
                  <DoctorList
                    docData={obj._source}
                    slug={slug}
                    drService={obj.services}
                    consti={index}
                    doctorServices={this.state.doctorServices}
                    favouriteDoctorsList={this.state.favouriteDoctorsList}
                  ></DoctorList>
                );
                // }
              })}
            </div>
            <div className="text-center">
              {this.state.doctorDataCount > 24 && (
                <Pagination
                  hideFirstLastPages
                  activePage={this.state.activePage}
                  itemsCountPerPage="24"
                  totalItemsCount={this.state.doctorDataCount}
                  pageRangeDisplayed="10"
                  onChange={this.handlePageChange.bind(this)}
                />
              )}
            </div>
          </div>
        </div>
        <Suspense fallback={<div></div>}>
          <section>
            {Footer && <Footer />}
          </section>
        </Suspense>
      </div>
    );
  }
}